// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".borders[data-v-14a4b906]:not(:first-of-type) {\n  border-left-width: 1px;\n}\n.borders[data-v-14a4b906]:not(:last-child) {\n  border-right-width: 1px;\n}", ""]);
// Exports
module.exports = exports;
